/* eslint-disable max-classes-per-file */
import { Expose, plainToInstance, Type } from 'class-transformer';
import { ArrayNotEmpty, ArrayUnique, IsArray, IsMongoId } from 'class-validator';

import { PaginatedResponseDto } from '../pagination/paginated.dto';
import type { PackingSlipNotificationPayload } from './notifications.interface';
import { NotificationType } from './notifications.interface';

export class NotificationResponseDto {
  @Expose()
  @Type(() => String)
  _id: string;

  @Expose()
  type: NotificationType;

  @Expose()
  payload: PackingSlipNotificationPayload;

  @Expose()
  createdAt: Date;

  @Expose()
  readAt?: Date;
}

export class NotificationsResponseDto {
  @Expose()
  @Type(() => NotificationResponseDto)
  notifications: NotificationResponseDto[];

  readonly meta: PaginatedResponseDto;

  constructor(data: any[], meta: PaginatedResponseDto) {
    this.meta = new PaginatedResponseDto(meta);
    this.notifications = plainToInstance(NotificationResponseDto, data, { excludeExtraneousValues: true });
  }
}

export class MarkNotificationAsReadDto {
  @IsArray()
  @ArrayNotEmpty()
  @ArrayUnique()
  @IsMongoId({ each: true })
  ids: string[];
}
